import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Download from 'yet-another-react-lightbox/plugins/download';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/counter.css';
import './LightBoxGallery.css';

function Gallery({ images, title, maxMain = 3, maxThumbnails = 8, showThumbnails = true }) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const mainImages = images.slice(0, maxMain);
  const extraImages = images.slice(maxMain);
  const extraCount = extraImages.length;

  const thumbnailsRef = React.useRef(null);

  const handleImageClick = idx => {
    setIndex(idx);
    setOpen(true);
  };

  const slides = images.map((imageObj, idx) => ({
    src: imageObj.src,
    title: imageObj.title || title,
  }));

  // Limit thumbnails
  const thumbnailsToShow = images.slice(0, maxThumbnails);
  const remainingCount = images.length - maxThumbnails;

  const handleDownload = async ({ slide }) => {
    const src = slide.src;
    const filename = `${(slide.title || title || 'image').toLowerCase().replace(/[^a-z0-9]+/g, '-')}.jpg`;

    try {
      const response = await fetch(src, { mode: 'cors' });
      if (!response.ok) throw new Error('Network response not ok');
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } catch {
      const link = document.createElement('a');
      link.href = src;
      link.download = filename;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div>
      {/* Main images */}
      <div style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
        {mainImages.map((imageObj, idx) => {
          const isLast = idx === maxMain - 1 && extraCount > 0;
          const imageTitle = imageObj.title || title;

          return (
            <div
              key={idx}
              style={{
                position: 'relative',
                flex: '1 1 100%',
                maxWidth: '100%',
                maxHeight: '400px',
                marginLeft: idx > 0 ? '2px' : 0,
                cursor: 'pointer',
              }}
              onClick={() => handleImageClick(idx)}
            >
              <img
                src={imageObj.src}
                alt={imageTitle}
                className="card-img-top img-fluid mb-1"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '100%',
                  objectFit: 'cover',
                }}
              />
              {isLast && maxMain !== 1 && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0,0,0,0.5)',
                    color: '#fff',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  +{extraCount}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Lightbox */}
      {open && (
        <Lightbox
          slides={slides}
          open={open}
          index={index}
          close={() => setOpen(false)}
          plugins={[Thumbnails, Counter, Download]}
          download={{ download: handleDownload }}
          thumbnails={{ ref: thumbnailsRef }}
          on={{
            click: () => {
              (thumbnailsRef.current?.visible
                ? thumbnailsRef.current?.hide
                : thumbnailsRef.current?.show)?.();
            },
          }}
        />
      )}

      {/* Thumbnails */}
      {showThumbnails && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
            gap: '5px',
          }}
        >
          {thumbnailsToShow.map((imageObj, idx) => (
            <div
              key={idx}
              style={{
                width: '80px',
                height: '80px',
                cursor: 'pointer',
                border: '2px solid #ddd',
                borderRadius: '5px',
                overflow: 'hidden',
                position: 'relative',
              }}
              onClick={() => handleImageClick(idx)}
            >
              <img
                src={imageObj.src}
                alt={imageObj.title || title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              {idx === maxThumbnails - 1 && remainingCount > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0,0,0,0.5)',
                    color: '#fff',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  +{remainingCount}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Gallery;
